import axios, { AxiosRequestConfig } from "axios";
import { AUTH_BEARER, AUTH_SESSION, TOKEN_ACCESS, TOKEN_SESSION } from "../constants";
import { getLocalStorage } from "./functions";

// 創建 Axios 實例
const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// POST 請求
export const axiosPost = async (
  url: string,
  data: any,
  extraHeaders?: Record<string, any>
) => {
  const config: AxiosRequestConfig = {
    headers: {
      ...extraHeaders,
    },
    withCredentials: true,
  };
  return await apiInstance.post(url, data, config);
};

// GET 請求
export const axiosGet = async (
  url: string,
  params?: Record<string, any>,
  extraHeaders?: Record<string, string>
) => {
  const config: AxiosRequestConfig = {
    headers: {
      ...extraHeaders,
    },
    params,
    withCredentials: true,
  };

  return await apiInstance.get(url, config);
};

// PUT 請求
export const axiosPut = (
  url: string,
  data: any,
  extraHeaders?: Record<string, string>
) => {
  const config: AxiosRequestConfig = {
    headers: {
      ...extraHeaders,
    },
    withCredentials: true,
  };

  return apiInstance.put(url, data, config);
};

// DELETE 請求
export const axiosDelete = (
  url: string,
  extraHeaders?: Record<string, string>
) => {
  const config: AxiosRequestConfig = {
    headers: {
      ...extraHeaders,
    },
    withCredentials: true,
  };

  return apiInstance.delete(url, config);
};

// PATCH 請求
export const axiosPatch = (
  url: string,
  data: any,
  extraHeaders?: Record<string, string>
) => {
  const config: AxiosRequestConfig = {
    headers: {
      ...extraHeaders,
    },
    withCredentials: true,
  };

  return apiInstance.patch(url, data, config);
};

export const getAuthorization = (authType: string) => {
  let token = '' as string | null;

  if (authType === AUTH_BEARER) {
    token = getLocalStorage(TOKEN_ACCESS);
  } else if (authType === AUTH_SESSION) {
    token = getLocalStorage(TOKEN_SESSION);
  }

  return { 'Authorization': `${authType} ${token}` }
};